import { Component, inject, signal } from '@angular/core';
import { Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';

import { MatButtonModule } from '@angular/material/button';

import { AuthService } from '@app/services/auth.service';
import { HeaderComponent } from '@app/common/header/header.component';
import { HttpService } from '@app/services/http.service';

@Component({
  selector: 'app-page-verify',
  imports: [HeaderComponent, MatButtonModule],
  templateUrl: './page.component.html',
  styleUrl: './page.component.scss',
})
export class VerifyComponent {
  loading = signal(false);

  private authService = inject(AuthService);
  private http = inject(HttpService);
  private router = inject(Router);

  resend() {
    this.loading.set(true);
    firstValueFrom(this.http.sendMyVerificationEmail())
      .catch(() => {
        // TODO Something
      })
      .finally(() => {
        this.loading.set(false);
      });
  }

  verify() {
    this.loading.set(true);
    this.authService
      .reloadUser()
      .then((account) => {
        if (account.verified) {
          void this.router.navigate(['/enrol'], { replaceUrl: true });
        } else {
          void this.router.navigate(['/signin'], {
            queryParams: { redirect: '/enrol' },
            replaceUrl: true,
          });
        }
      })
      .catch(() => {
        void this.router.navigate(['/signin']);
      })
      .finally(() => {
        this.loading.set(false);
      });
  }
}
